"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceClientCredentialsFactory = void 0;
/**
 * The ServiceClientCredentialsFactory abstract class that allows Bots to provide their own
 * ServiceClientCredentials for bot to bot channel or skill bot to parent bot calls.
 */
class ServiceClientCredentialsFactory {
}
exports.ServiceClientCredentialsFactory = ServiceClientCredentialsFactory;
//# sourceMappingURL=serviceClientCredentialsFactory.js.map